<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="mb-0 font-medium text-uppercase">
            <router-link to="/apps/users" class="text-center navbar-brand">
              <strong>
                <i class="fas fa-chevron-left"></i> Back
              </strong>
            </router-link>
            <span>Edit Team</span>
            <span v-if="hasSalesContract" class="badge badge-success ml-2">Enterprise</span>
          </h5>
        </div>
        <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
          <nav aria-label="breadcrumb" class="float-left mt-2 float-md-right">
            <ol class="p-0 mb-0 breadcrumb justify-content-end">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/apps/teams">Teams</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">{{id}}</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->
      <div class="card">
        <div class="card-body">
          <form class="col-md-6" @submit.prevent="submit">
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Team Name</label>

              <div class="col-sm-8">
                <input
                  v-model="teamAccount.name"
                  type="text"
                  class="form-control"
                  required
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Quantity License</label>

              <div class="col-sm-8">
                <input
                  v-model="teamAccount.licenseQuantity"
                  type="number"
                  class="form-control"
                  required
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Plan</label>

              <div class="col-sm-8">
                <select v-model="teamAccount.plan" class="form-control" name="invitedPlan">
                  <optgroup v-for="group in groups" :key="group.name" :label="group.name">
                    <option v-for="plan in group.plans" :key="plan.type" :value="plan.type">{{ `${plan.name} ($${plan.price})` }}</option>
                  </optgroup>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Plan End At</label>

              <div class="col-sm-8">
                <input
                  v-model="teamAccount.planEndAt"
                  type="datetime-local"
                  class="form-control"
                />
              </div>
            </div>
            <div v-if="id !== 'new'" class="text-center form-group">
              <button
                class="btn btn-primary btn-sm"
                type="submit"
                style="margin-left: 10px"
              >Save changes <i v-if="submiting" class="fa fa-spin fa-spinner"></i></button>
            </div>
            <div v-if="id === 'new'" class="text-center form-group">
              <button
                class="btn btn-primary btn-sm"
                type="submit"
                style="margin-left: 10px"
                :disabled="submiting"
              >Create new team <i v-if="submiting" class="fa fa-spin fa-spinner"></i></button>
            </div>
          </form>
        </div>
      </div>


      <!-- config SSO -->
      <div v-if="teamAccount.id" class="card">
        <div class="card-header">SSO CONFIG</div>
        <div class="card-body">
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              <div>SSO Domains</div>
              <div class="small-text">ahaslide.com, ahaslides.com</div>
            </label>
            <div class="col-sm-6">
              <input
                v-model="teamAccount.ssoDomains"
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <div v-if="teamAccount.ssoDomains" class="form-group row">
            <label class="col-sm-2 col-form-label">
              <div>Enforce SSO login</div>
            </label>
            <div class="col-sm-6">
              <b-form-checkbox
                v-model="teamAccount.enforceSsoLogin"
                switch
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              <div>Provider Name</div>
            </label>
            <div class="col-sm-6">
              <input
                v-model="teamAccount.providerName"
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              <div>Entry Point</div>
            </label>
            <div class="col-sm-6">
              <input
                v-model="teamAccount.samlOptions.entryPoint"
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              <div>Issuer</div>
            </label>
            <div class="col-sm-6">
              <input
                v-model="teamAccount.samlOptions.issuer"
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              <div>Cert</div>
            </label>
            <div class="col-sm-6">
              <textarea
                v-model="teamAccount.samlOptions.cert"
                class="form-control"
                rows="4"
              >
              </textarea>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              <div>Identifier format</div>
            </label>
            <div class="col-sm-6">
              <input
                v-model="teamAccount.samlOptions.identifierFormat"
                type="text"
                class="form-control"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              <div>Callback URL</div>
            </label>
            <div class="col-sm-6">
              <input
                v-model="teamAccount.samlOptions.callbackUrl"
                type="text"
                class="form-control"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              <div>Logout Url</div>
            </label>
            <div class="col-sm-6">
              <input
                v-model="teamAccount.samlOptions.logoutUrl"
                type="text"
                class="form-control"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              <div>First name attribute</div>
            </label>
            <div class="col-sm-6">
              <input
                v-model="teamAccount.samlOptions.firstNameAttribute"
                type="text"
                class="form-control"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              <div>Last name attribute</div>
            </label>
            <div class="col-sm-6">
              <input
                v-model="teamAccount.samlOptions.lastNameAttribute"
                type="text"
                class="form-control"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              <div>Email attribute</div>
            </label>
            <div class="col-sm-6">
              <input
                v-model="teamAccount.samlOptions.emailAttribute"
                type="text"
                class="form-control"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              <div>Microsoft Entra</div>
            </label>
            <div class="col-sm-6">
              <textarea
                v-model="teamAccount.samlOptions.microsoftEntraOptions"
                class="form-control"
                rows="4"
                placeholder='{"clientId": "...", "tenantId": "...", "clientSecret": "..."}'
              >
              </textarea>
            </div>
          </div>

          <div class="text-center form-group">
            <button
              class="btn btn-primary btn-sm"
              type="button"
              style="margin-left: 10px"
              :disabled="submitingSsoConfig"
              @click="updateSettingSso()"
            >Save changes <i v-if="submitingSsoConfig" class="fa fa-spin fa-spinner"></i></button>
          </div>
        </div>
      </div>

      <div v-if="teamAccount.id" class="">
        <div class="row">
          <div class="col-12">
            <h5 class="text-uppercase">Team</h5>

            <div class="card">
              <div class="card-body table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="th-date">Name</th>
                      <th class="th-date">Email</th>
                      <th class="th-description">Last activity</th>
                      <th class="th-amount">Usage</th>
                      <th class="th-amount">Role</th>
                      <th class="th-payment-method">Joined</th>
                      <th class="text-center th-action">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="accountUsers.length">
                    <tr
                      v-for="(item, index) in accountUsers"
                      :key="index"
                      style="width:100%;"
                      class="table-data-body"
                    >
                      <td class="receipt-date">
                        {{ item.firstName }} {{ item.lastName }}
                      </td>
                      <td>
                        <span
                          class="pointer text-primary break-any"
                          @click="goToDetail(item.id)"
                        >
                          {{ item.email }}
                        </span>
                      </td>
                      <td>
                        <span>
                          {{ item.lastActivity }}
                        </span>
                      </td>
                      <td>
                        <span>
                          {{ item.presentationCount }} presentation(s), {{ item.onlineCount }} total live participant(s)
                        </span>
                      </td>
                      <td>
                        <span
                          class="text-uppercase"
                          :class="{
                            'text-success': item.accountRole === 'admin',
                            'text-muted': item.accountRole !== 'admin',
                          }"
                        >
                          {{ item.accountRole }}
                        </span>
                      </td>
                      <td>
                        <span>
                          {{ item.joinedAt }}
                        </span>
                      </td>
                      <td class="text-center">
                        <span
                          class="pointer text-danger"
                          @click="removeUser(item.id)"
                        >
                          <i class="fas fa-trash-alt" />
                        </span>
                      </td>
                    </tr>
                    <tr v-if="accountUsers.length == 1" class="one-receipt--row">
                      <td class="border-0" />
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>

            <div
              class="text-center form-group"
            >
              <button
                class="btn btn-primary btn-sm"
                style="margin-left: 10px"
                @click="showAddMember()"
              >Add new member</button>
            </div>
          </div>
        </div>
      </div>

      <!-- CS licence view (aha-team-management embed). Renders the
           /admin/teams/:accountId route of the team-mgmt app inside an
           iframe so we don't have to re-implement the licence table
           and grant/revoke actions here. -->
      <div v-if="teamAccount.id" class="row">
        <div class="col-12">
          <h5 class="text-uppercase">Team Licences</h5>
          <div class="card">
            <div class="card-body">
              <TeamLicensesEmbed :account-id="teamAccount.id" />
            </div>
          </div>
        </div>
      </div>
    </div>
 
    <b-modal
      id="add-member-modal"
      ref="add-new-member-modal"
      hide-footer
      title="Add member to team"
      size="xl"
    >
      <div class="d-block form-group">
        <label for="exampleInputEmail1">Pick user to add</label>
        <vue-bootstrap-typeahead 
          v-model="memberSearch"
          :data="memberList"
          :serializer="s => s.note || `${s.email} (${
            s.accountId
            ? 'Already in team'
            : s.accountId
            ? 'Another team, role: ' + s.accountRole
            : 'Not in any team'
          })`"
          placeholder="Type to search.."
          @hit="selectedMember = $event"
        />
        <div v-if="!selectedMember && memberSearch && !memberList.length" class="mt-2 text-danger">User not found</div>
      </div>
      <div
       class="text-center"
      >
        <button
         type="button"
         class="mr-2 btn btn-primary" :disabled="!selectedMember && !memberSearch"
         @click.prevent="addMember"
        >
          Add member
          <i v-if="isAddingMember" class="fa fa-spinner fa-spin"></i>
        </button>
        <button type="button" class="btn btn-light" @click="hideAddMember">Cancel</button>
      </div>
    </b-modal>

  </div>
</template>

<script>
// @ is an alias to /src
import Config from '@/config'
import moment from 'moment'
import Utils  from "@/utils"
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import _ from 'lodash'
import AccountsAPI from '@/api/accounts'
import TeamLicensesEmbed from './TeamLicensesEmbed.vue'

export default {
  name: "TeamDetail",
  components: {VueBootstrapTypeahead, TeamLicensesEmbed},
  data() {
    return {
      teamAccount: {},
      groups: [],
      submiting: false,
      accountUsers: [],
      isDeletingAccount: false,
      memberSearch: '',
      memberList: [],
      selectedMember: null,
      isAddingMember: false,
      domainName: '',
      submitingSsoConfig: false,
      hasSalesContract: false
    }
  },
  created() {
    this.init()
  },
  watch: {
    memberSearch: _.debounce(function(text) { 
      this.getUserList(text)
    }, 500),
    '$route': function(){
      this.init()
    },
  },
  mounted() {
  },
  methods: {
    async init() {
      this.id = this.$route.params.id
      await this.getPlanList()
      if (this.id !== 'new') {
        const res = await this.$http.get(`${Config.api.getListAccount}${this.id}`)
        if (res.body.account.planEndAt) {
          res.body.account.planEndAt = moment(res.body.account.planEndAt).format('YYYY-MM-DDTHH:mm')
        }
        if (!res.body.account.ssoDomains) {
          res.body.account.ssoDomains = ''
        } else {
          res.body.account.ssoDomains = res.body.account.ssoDomains.toString()
        }
        res.body.account.enforceSsoLogin = !!res.body.account.enforceSsoLogin

        if (!res.body.account.samlOptions) res.body.account.samlOptions = {
          callbackUrl: '',
          entryPoint: '',
          issuer: '',
          cert: '',
        }
        this.teamAccount = res.body.account
        this.loadAccount()
        this.checkSalesContract()
        console.log(this.teamAccount)
      }
    },
    async loadAccount() {
      const res = await this.$http.get(`${Config.api.getListAccount}${this.teamAccount.id}/users`)
      const { users } = res.body
      this.accountUsers = users.map(
        i => ({
          ...i,
          lastActivity: Utils.isoDateTime(i.lastActivity || i.createdAt),
          joinedAt: Utils.isoDateTime(i.accountData && i.accountData.joinedAt),
        })
      )
    },
    async getPlanList() {
      this.$http
        .get(Config.api.planList)
        .then(res => {
          const plans = res.body
            .filter((p) => p.group !== 'one-time')
            .reduce((acc, p) => {
              if (acc[p.group]) {
                acc[p.group].push(p)
              } else {
                acc[p.group] = [p]
              }
              return acc
            }, {})
          this.groups = Object.keys(plans).map((k) => ({
            name: k[0].toUpperCase() + k.slice(1),
            plans: plans[k],
          }))
        })
    },

    async submit () {
      if (this.submiting) return
      this.submiting = true
      let payload = {
        name: this.teamAccount.name,
        licenseQuantity: this.teamAccount.licenseQuantity,
        plan: this.teamAccount.plan,
        planEndAt: this.teamAccount.planEndAt,
      }
      if (this.id === 'new') {
        payload.planEndAt = new Date(this.teamAccount.planEndAt)
        const res = await this.$http.post(Config.api.getListAccount, payload)
        this.$router.push({name: "TeamDetail", params: { id: res.body.account.id }})
      } else {
        payload.planEndAt = new Date(this.teamAccount.planEndAt)
        await this.$http.patch(`${Config.api.getListAccount}${this.id}`, payload)
      }
      this.submiting = false
    },
    goToDetail(id) {
      this.$router.push({name: 'UserDetail', params: { id } })
    },
    removeUser(userId) {
      let cf = confirm(
        "Are you sure that you want to remove this user from the team?"
      )
      if (!cf || this.isDeletingAccount) return
      this.isDeletingAccount = true

      this.$http.delete(Config.api.account + userId)
        .then(
          () => {
            this.isDeletingAccount = false
            this.loadAccount()
          },
          (err) => {
            this.isDeletingAccount = false
            alert("something went wrong, pls contact admin.")
            console.error(err)
          }
        )

    },
    showAddMember() {
      this.selectedMember = null
      this.memberSearch = ''
      this.memberList = []
      this.$refs["add-new-member-modal"].show()
    },

    hideAddMember() {
      this.$refs["add-new-member-modal"].hide()
    },

    addMember() {
      this.isAddingMember = true
      this.$http.post(`${Config.api.updateUser}${this.selectedMember.id}/add-team`, {
        accountId: this.teamAccount.id,
        accountRole: 'editor',
      })
        .then(
          () => {
            this.isAddingMember = false
            this.hideAddMember()
            this.init()
          },
          (err) => {
            this.isAddingMember = false
            alert(err.body && err.body.message)
            console.error(err)
          }
        )
    },

    getUserList() {
      this.$http
        .get(Config.api.getListUsers, {
          params: {
            textSearch: this.memberSearch,
          }
        })
        .then(res => {
          this.memberList = res.body.result.filter((u) => {
            return u.active
          })
        })
    },

    async updateSettingSso() {
      if (this.submitingSsoConfig) return

      if (this.teamAccount.samlOptions.microsoftEntraOptions) {
        this.teamAccount.samlOptions.microsoftEntraOptions = JSON.parse(JSON.stringify(this.teamAccount.samlOptions.microsoftEntraOptions))
      }
      const ssoDomains = this.teamAccount.ssoDomains.split(',')
      const hasSsoDomains = ssoDomains.some((domain) => domain.trim())
      const payload = {
        ssoDomains,
        samlOptions: this.teamAccount.samlOptions,
        providerName: this.teamAccount.providerName,
        // Enforcement without a domain would lock the whole team out of login, so never persist it true when no domain is set
        enforceSsoLogin: hasSsoDomains && this.teamAccount.enforceSsoLogin
      }
      try {
        await this.$http.patch(`${Config.api.getListAccount}${this.id}`, payload)
        this.$toasted.success('Save SSO Config Done!')
      } catch (error) {
        const errorMessage = (error.body && error.body.message) || error.bodyText || 'Failed to save SSO Config'
        this.$toasted.error(errorMessage)
      }
      this.submitingSsoConfig = false
    },

    async checkSalesContract() {
      if (this.id === 'new') return
      
      try {
        const salesContracts = await AccountsAPI.getSalesAssistedContract({ 
          accountIds: [this.id] 
        })
        this.hasSalesContract = Utils.hasEnterpriseContract(salesContracts, this.id)
      } catch (error) {
        console.error('Error fetching sales contract:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.description {
  display: inline-block;
  max-height: 100px;
  max-width: 350px;
  overflow: auto;
}
.break-any {
  word-wrap: anywhere;
}
.small-text {
  font-size: 12px;
  color: #888;
}
</style>
